module.exports = __webpack_public_path__ + "static/media/viber_bg.ff9685d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viber_bg.png
// module id = 40
// module chunks = 0